import { c as _c } from "react/compiler-runtime";
import { IcoShield24 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
export type ForbiddenProps = {
  title?: string;
  description?: string;
  className?: string;
};
const Forbidden = t0 => {
  const $ = _c(20);
  const {
    title,
    description,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.forbidden"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== className) {
    t2 = cx("flex flex-1 w-full items-center justify-center p-6", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div aria-hidden={true} className="flex items-center justify-center h-16 w-16 mb-6 rounded-default border border-tertiary bg-secondary"><IcoShield24 color="tertiary" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t || $[5] !== title) {
    t4 = title ?? t(_temp);
    $[4] = t;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h3 className="text-label-2 text-primary mb-2 fp-text">{t4}</h3>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== description || $[10] !== t) {
    t6 = description ?? t(_temp2);
    $[9] = description;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <p className="text-body-3 text-secondary fp-text">{t6}</p>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="flex flex-col items-center w-full max-w-[420px] text-center">{t3}{t5}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8) {
    t9 = <div className={t2}>{t8}</div>;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default Forbidden;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}